module.exports = __webpack_public_path__ + "47612ada7a40228697740ba08599f563.MP3";